<template>
    <div>
        <SelectEsporteComponent
            id="select"
            show
            @select="select"
            @hide="close"
        />
    </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import SelectEsporteComponent from "../components/SelectEsporteComponent.vue";

const router = useRouter();

const close = () => {
    router.push("/");
};
const select = (id) => {
    router.push(`board?esporte=${id}&board=1`);
};
</script>
